import axios from 'axios';

import {callAPI} from './Base';

class Products { 
  
    constructor(){
        this.cache = {
            featuredCycles : null,
            categories: {
                'cycles' : '',
                'accessories' : '',
            },
            products: {},
            allProducts: {},
        };
    }

    getAllProductsCacheKey(data = {}) {
        const normalize = (val) => (Array.isArray(val) ? val.slice().sort().join(',') : String(val || ''));
        return [
            normalize(data.productType),
            normalize(data.buildFor),
            normalize(data.onSale),
            normalize(data.catID),
        ].join('|');
    }

    getFeaturedCycles(callback, useCache = true){
        
        if( this.cache.featuredCycles && useCache) {
            callback(this.cache.featuredCycles);
            return;
        }

        axios.get( callAPI('GetFeaturedCycles') )
            .then( (response) => {

                this.cache.featuredCycles = response;				  
                callback(response);
           
            })
            .catch(function (error) {
                console.log(error); 
            });	 
        
    }


    getCatgories(type, callback, useCache = true){

        if( type === 'CYCLES' ) {
            if( this.cache.categories.cycles && useCache) {
                callback(this.cache.categories.cycles);
                return;
            }
        } else {
            if( this.cache.categories.accessories && useCache) {
                callback(this.cache.categories.accessories);
                return;
            }
        }

        axios.get( callAPI('GetCategories\\' + type) )
            .then( (response) => {
                if( type === 'CYCLES' ) {
                    this.cache.categories.cycles      = response;            
                } else {                   
                    this.cache.categories.accessories = response;            
                }
                callback(response);           
            })
            .catch(function (error) {
                console.log(error); 
            });  
        
    }

    getProduct(data, callback, useCache = true){
        const cacheKey = `${data.productType}:${data.productURI}`;

        if (useCache && this.cache.products[cacheKey]) {
            callback(this.cache.products[cacheKey]);
            return;
        }

        axios.get( callAPI('GetProduct/' + data.productType + '/' + data.productURI) )
            .then( (response) => {
                this.cache.products[cacheKey] = response;
                callback(response);  

            })
            .catch(function (error) {
                console.log(error); 
            });	
    }

    getAllProducts(data, callback, useCache = true) {
        const cacheKey = this.getAllProductsCacheKey(data);

        if (useCache && this.cache.allProducts[cacheKey]) {
            callback(this.cache.allProducts[cacheKey]);
            return;
        }

        let fd = new FormData();

        for( let attr in data) {
            fd.append( attr, data[attr]);
        }

        axios({
            method: 'POST',
            url: callAPI('GetProduct/' + data.productType),
            data: fd,
        }).then(( response ) => {
            this.cache.allProducts[cacheKey] = response;
            callback( response );
        }).catch(function (error) {
            console.log(error);
        });
    }
    
    
    
}

let prd = new Products();

export default prd;


// WEBPACK FOOTER //
// ./src/Core/Products.js